
/**
 * 这里放开关配置
 */
export default {
  enableShiplyAbTestTag: false,
  enableAbTestTag: true,
  showShiplyTag: false,
  showTapd: false,
  enableBatchCancel: false,
  enableTapdHandler: true,
  enableGPT: false,
  enableBatchStatus: true,
  enableBatchCreateTapd: false,
  enableComplianceAnalyticTab: false,
  enableComplianceIssueSetting: false,
  enableTapd: true,
  enablePreviewSourceCode: false,
};
